import React from "react";
import { Select } from "semantic-ui-react";

const PeriodSelect = (props) => {
  const options = [
    {
      key: "Current Week",
      text: "Current Week",
      value: 1,
    },
    {
      key: "Date Period",
      text: "Date Period",
      value: 2,
    },
    {
      key: "Collection Week",
      text: "Collection Week",
      value: 3,
    },
  ];
  return <Select {...props} options={options} name="useCollectionWeek" />;
};

export default PeriodSelect;
